import React from 'react';
import { Helmet } from 'react-helmet-async';
import PodcastNotes from './PodcastNotes';
import { AppPdfPage } from '../../ttg';
import {useLocation} from "react-router-dom";
import {getQueryParams} from "../../services/UtilityService";
import PodcastService from "../../services/PodcastService";

const TTGPodcastPdf = () => {
    const location = useLocation();
    const params = getQueryParams(location.search);
    const podcast = PodcastService.getPodcastData(params);

    const renderContent = () => {
        if (!podcast) {
            return null;
        }

        return <PodcastNotes podcast={podcast} />;
    };

	return (
		<AppPdfPage className={'ttg-podcast-pdf'}>
			<Helmet>
				<meta charSet='UTF-8' />
				<meta name='viewport' content='width=device-width, initial-scale=1.0' />
				<meta httpEquiv='X-UA-Compatible' content='ie=edge' />
				<title>The Table Group Podcast Pdf</title>
			</Helmet>
			{renderContent()}
		</AppPdfPage>
	);
};

export default TTGPodcastPdf;
